import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "py-6 px-10" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "flex items-center gap-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus mr-2" }, null, -1)
const _hoisted_6 = { class: "bg-white rounded-2xl p-5 mt-6" }
const _hoisted_7 = { class: "grid grid-cols-4 gap-4" }
const _hoisted_8 = { class: "flex items-center justify-end gap-4 mt-4" }
const _hoisted_9 = { class: "bg-white rounded-2xl p-5 mt-6" }
const _hoisted_10 = {
  key: 0,
  class: "flex flex-col items-center justify-center gap-4"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "text-red-500 text-sm" }, "При получении периодов произошла ошибка", -1)
const _hoisted_12 = {
  key: 2,
  class: "text-sm"
}
const _hoisted_13 = {
  key: 1,
  class: "grid grid-cols-1 gap-5"
}
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<div class=\"p-6 rounded-xl\" style=\"box-shadow:0px 2px 6px 0px #1D1D1D26;\"><div class=\"flex items-center justify-between\"><div class=\"flex items-center gap-5\"><svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13.5 3V3.5H0.5V3C0.5 2.173 1.173 1.5 2 1.5H2.5V1C2.5 0.7235 2.724 0.5 3 0.5C3.276 0.5 3.5 0.7235 3.5 1V1.5H6.5V1C6.5 0.7235 6.724 0.5 7 0.5C7.276 0.5 7.5 0.7235 7.5 1V1.5H10.5V1C10.5 0.7235 10.724 0.5 11 0.5C11.276 0.5 11.5 0.7235 11.5 1V1.5H12C12.827 1.5 13.5 2.173 13.5 3ZM15.5 12C15.5 13.9325 13.933 15.5 12 15.5C10.067 15.5 8.5 13.9325 8.5 12C8.5 10.0675 10.067 8.5 12 8.5C13.933 8.5 15.5 10.0675 15.5 12ZM14 12C14 11.7235 13.776 11.5 13.5 11.5H12.5V10.5C12.5 10.2235 12.276 10 12 10C11.724 10 11.5 10.2235 11.5 10.5V12C11.5 12.2765 11.724 12.5 12 12.5H13.5C13.776 12.5 14 12.2765 14 12ZM13.5 4.5V7.76C13.03 7.59 12.525 7.5 12 7.5C9.52 7.5 7.5 9.52 7.5 12C7.5 12.525 7.59 13.03 7.76 13.5H2C1.175 13.5 0.5 12.825 0.5 12V4.5H13.5ZM5 11C5 10.7235 4.776 10.5 4.5 10.5H3.5C3.224 10.5 3 10.7235 3 11C3 11.2765 3.224 11.5 3.5 11.5H4.5C4.776 11.5 5 11.2765 5 11ZM5 9C5 8.7235 4.776 8.5 4.5 8.5H3.5C3.224 8.5 3 8.7235 3 9C3 9.2765 3.224 9.5 3.5 9.5H4.5C4.776 9.5 5 9.2765 5 9ZM5 7C5 6.7235 4.776 6.5 4.5 6.5H3.5C3.224 6.5 3 6.7235 3 7C3 7.2765 3.224 7.5 3.5 7.5H4.5C4.776 7.5 5 7.2765 5 7ZM8 7C8 6.7235 7.776 6.5 7.5 6.5H6.5C6.224 6.5 6 6.7235 6 7C6 7.2765 6.224 7.5 6.5 7.5H7.5C7.776 7.5 8 7.2765 8 7Z\" fill=\"#3B82F6\"></path></svg><div class=\"text-sm font-semibold uppercase\">Стандартный период</div><div class=\"text-xs bg-green-100 text-green-500\" style=\"padding:1.5px 14px;border-radius:26px;\">Активен</div></div><div class=\"flex items-center gap-3\"></div></div><div class=\"mt-5 flex items-center text-center justify-center p-6\" style=\"border-radius:10px;background-color:#DBEAFE4D;\"><p class=\"text-sm font-semibold\">Стандартный период действует по умолчанию</p></div></div>", 1)
const _hoisted_15 = { class: "flex items-center justify-between" }
const _hoisted_16 = { class: "flex items-center gap-5" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M13.5 3V3.5H0.5V3C0.5 2.173 1.173 1.5 2 1.5H2.5V1C2.5 0.7235 2.724 0.5 3 0.5C3.276 0.5 3.5 0.7235 3.5 1V1.5H6.5V1C6.5 0.7235 6.724 0.5 7 0.5C7.276 0.5 7.5 0.7235 7.5 1V1.5H10.5V1C10.5 0.7235 10.724 0.5 11 0.5C11.276 0.5 11.5 0.7235 11.5 1V1.5H12C12.827 1.5 13.5 2.173 13.5 3ZM15.5 12C15.5 13.9325 13.933 15.5 12 15.5C10.067 15.5 8.5 13.9325 8.5 12C8.5 10.0675 10.067 8.5 12 8.5C13.933 8.5 15.5 10.0675 15.5 12ZM14 12C14 11.7235 13.776 11.5 13.5 11.5H12.5V10.5C12.5 10.2235 12.276 10 12 10C11.724 10 11.5 10.2235 11.5 10.5V12C11.5 12.2765 11.724 12.5 12 12.5H13.5C13.776 12.5 14 12.2765 14 12ZM13.5 4.5V7.76C13.03 7.59 12.525 7.5 12 7.5C9.52 7.5 7.5 9.52 7.5 12C7.5 12.525 7.59 13.03 7.76 13.5H2C1.175 13.5 0.5 12.825 0.5 12V4.5H13.5ZM5 11C5 10.7235 4.776 10.5 4.5 10.5H3.5C3.224 10.5 3 10.7235 3 11C3 11.2765 3.224 11.5 3.5 11.5H4.5C4.776 11.5 5 11.2765 5 11ZM5 9C5 8.7235 4.776 8.5 4.5 8.5H3.5C3.224 8.5 3 8.7235 3 9C3 9.2765 3.224 9.5 3.5 9.5H4.5C4.776 9.5 5 9.2765 5 9ZM5 7C5 6.7235 4.776 6.5 4.5 6.5H3.5C3.224 6.5 3 6.7235 3 7C3 7.2765 3.224 7.5 3.5 7.5H4.5C4.776 7.5 5 7.2765 5 7ZM8 7C8 6.7235 7.776 6.5 7.5 6.5H6.5C6.224 6.5 6 6.7235 6 7C6 7.2765 6.224 7.5 6.5 7.5H7.5C7.776 7.5 8 7.2765 8 7Z",
    fill: "#3B82F6"
  })
], -1)
const _hoisted_18 = { class: "text-sm font-semibold uppercase" }
const _hoisted_19 = { class: "flex items-center gap-3" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M10.869 2.86902C11.4939 2.24418 12.5069 2.24418 13.1318 2.86902C13.7566 3.49386 13.7566 4.50692 13.1318 5.13176L12.4974 5.76608L10.2347 3.50333L10.869 2.86902Z",
    fill: "#94A3B8"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M9.10333 4.63471L2.40039 11.3376V13.6004H4.66313L11.3661 6.89745L9.10333 4.63471Z",
    fill: "#94A3B8"
  })
], -1)
const _hoisted_21 = { class: "mt-5 flex flex-wrap items-center gap-3" }
const _hoisted_22 = { class: "mt-5 flex items-center gap-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_nv_period_badge = _resolveComponent("nv-period-badge")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_page_title, { title: "Управление периодами" }),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, { to: "/time-slots/list" }, {
          default: _withCtx(() => [
            _createVNode(_component_the_button, { class: "second small text" }, {
              default: _withCtx(() => [
                _hoisted_4,
                _createTextVNode(" Назад ")
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, { to: "/time-slots/periods/create" }, {
          default: _withCtx(() => [
            _createVNode(_component_the_button, { class: "primary small" }, {
              default: _withCtx(() => [
                _hoisted_5,
                _createTextVNode(" Создать период ")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_the_input, {
          type: "date",
          placeholder: "Дата от",
          value: _ctx.filters_state.dateFrom,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters_state.dateFrom) = $event)),
          disabled: _ctx.state.is_loading,
          "is-invalid": _ctx.filters_state_form$.dateFrom.$invalid,
          "validation-errors": _ctx.filters_state_form$.dateFrom.$errors
        }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"]),
        _createVNode(_component_the_input, {
          type: "date",
          placeholder: "Дата по",
          value: _ctx.filters_state.dateTo,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters_state.dateTo) = $event)),
          disabled: _ctx.state.is_loading,
          "is-invalid": _ctx.filters_state_form$.dateTo.$invalid,
          "validation-errors": _ctx.filters_state_form$.dateTo.$errors
        }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"]),
        _createVNode(_component_the_select, {
          class: "mt-2",
          "can-deselect": "",
          "search-without-refresh": "",
          multiselect: "",
          placeholder: "Секторы",
          options: _ctx.data_state.sectors.list,
          loading: _ctx.data_state.sectors.is_loading,
          failed: _ctx.data_state.sectors.is_failed,
          disabled: _ctx.data_state.sectors.is_loading || _ctx.state.is_loading,
          value: _ctx.filters_state.dispatcherSectorIds,
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters_state.dispatcherSectorIds) = $event)),
          onRefresh: _ctx.loadSectors
        }, null, 8, ["options", "loading", "failed", "disabled", "value", "onRefresh"]),
        _createVNode(_component_the_select, {
          class: "mt-2",
          "can-deselect": "",
          placeholder: "Статус",
          searchable: false,
          options: _ctx.STATUSES,
          disabled: _ctx.state.is_loading,
          value: _ctx.filters_state.statusId,
          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters_state.statusId) = $event))
        }, null, 8, ["options", "disabled", "value"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_the_button, {
          type: "button",
          class: "small text second",
          disabled: _ctx.state.is_loading,
          onClick: _ctx.onResetFilters
        }, {
          default: _withCtx(() => [
            _createTextVNode("Сбросить")
          ]),
          _: 1
        }, 8, ["disabled", "onClick"]),
        _createVNode(_component_the_button, {
          type: "button",
          class: "small text primary",
          loading: _ctx.state.is_loading,
          onClick: _ctx.loadPeriods
        }, {
          default: _withCtx(() => [
            _createTextVNode("Поиск")
          ]),
          _: 1
        }, 8, ["loading", "onClick"])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      (_ctx.state.is_loading || _ctx.state.is_failed || _ctx.state.periods.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            (_ctx.state.is_loading)
              ? (_openBlock(), _createBlock(_component_Loader, {
                  key: 0,
                  class: "primary"
                }))
              : (_ctx.state.is_failed)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _hoisted_11,
                    _createVNode(_component_the_button, {
                      type: "button",
                      class: "primary small",
                      onClick: _ctx.loadPeriods
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Обновить")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ], 64))
                : (_ctx.state.periods.length === 0)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_12, "Список пуст"))
                  : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _hoisted_14,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.periods, (period) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "p-6 rounded-xl",
                style: {"box-shadow":"0px 2px 6px 0px #1D1D1D26"},
                key: period.id
              }, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _createElementVNode("div", _hoisted_18, _toDisplayString(period.name), 1),
                    _createElementVNode("div", {
                      class: _normalizeClass(["text-xs", {
                                    'bg-green-100 text-green-500': period.statusId === 41,
                                    'bg-red-100 text-red-500': period.statusId === 42
                                }]),
                      style: {"padding":"1.5px 14px","border-radius":"26px"}
                    }, [
                      (period.statusId === 41)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode("Активен")
                          ], 64))
                        : _createCommentVNode("", true),
                      (period.statusId === 42)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode("Неактивен")
                          ], 64))
                        : _createCommentVNode("", true)
                    ], 2)
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_router_link, {
                      to: `/time-slots/periods/update/${period.id}`
                    }, {
                      default: _withCtx(() => [
                        _hoisted_20
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(period.sectors, (sector) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: sector.id,
                      class: "text-xs",
                      style: {"background-color":"#DBEAFE","padding":"4px 14px","border-radius":"26px"}
                    }, _toDisplayString(sector.name), 1))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_22, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(period.ranges, (range, i) => {
                    return (_openBlock(), _createBlock(_component_nv_period_badge, {
                      key: `range-${i}`,
                      period: _ctx.rangeToCalendarPeriod(range)
                    }, null, 8, ["period"]))
                  }), 128))
                ])
              ]))
            }), 128))
          ]))
    ])
  ]))
}